// src/contexts/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within an AuthProvider');
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // ── Restore session on page reload ────────────────────────────────────────
  useEffect(() => {
    const access_token = localStorage.getItem('access_token');
    const user_id      = localStorage.getItem('user_id');
    const user_email   = localStorage.getItem('user_email');
    const role         = localStorage.getItem('role');

    console.log('🔄 AuthContext restore:', { access_token: access_token?.slice(0,20), user_id, user_email, role });

    if (access_token && user_email) {
      setUser({ id: user_id, email: user_email, name: user_email.split('@')[0], role });
    }
    setLoading(false);
  }, []);


  // ── login(apiResponse, email) ─────────────────────────────────────────────
  // apiResponse = { access_token, refresh_token, token_type, user_id, role }
  // email       = the email string user typed in the login form
  const login = (apiResponse, email) => {

    // ── Guard: detect if called with wrong arguments ──────────────────────
    if (typeof apiResponse === 'string') {
      console.error('❌ login() called wrong! First arg is a string (token?), not an object.');
      console.error('   Fix your Login screen: login(apiResponseObject, emailString)');
      return;
    }

    console.log('💾 login() called with:', { apiResponse, email });

    const { access_token, refresh_token, token_type, user_id, role } = apiResponse;

    if (!access_token) console.error('❌ access_token missing from apiResponse');
    if (!user_id)      console.error('❌ user_id missing from apiResponse');
    if (!role)         console.error('❌ role missing from apiResponse');
    if (!email)        console.error('❌ email not passed to login()');

    localStorage.setItem('access_token',  access_token);
    localStorage.setItem('refresh_token', refresh_token  || '');
    localStorage.setItem('token_type',    token_type     || 'bearer');
    localStorage.setItem('user_id',       user_id        || '');
    localStorage.setItem('user_email',    email          || '');
    localStorage.setItem('role',          role           || '');

    setUser({
      id:    user_id,
      email: email,
      name:  email ? email.split('@')[0] : '',
      role:  role,
    });

    console.log('✅ localStorage saved. role:', role, '| user_id:', user_id);
  };


  // ── logout ────────────────────────────────────────────────────────────────
  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('token_type');
    localStorage.removeItem('user_id');
    localStorage.removeItem('user_email');
    localStorage.removeItem('role');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};